<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" :before-query-search="beforeQuerySearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessImportHistory.page.importTemplate')" prop="templateCode">
            <BjSelectImportTemplate v-model="queryParams.templateCode" @change="handleChangeTemplate" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.createTimeText')">
            <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('table.createTimeText')"/>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'financeStatus'"> </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { commonApi } from '@/api';
export default {
  name: 'BusinessImportHistoryIndex',
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 6,
      selection: false,
      queryApi: commonApi.getImportManager,
      // 查询参数
      queryParams: {
        templateCode: 'SFIN.BILL_JD',
        prefix: '/sfin',
        creationDateFrom: null,
        creationDateTo: null,
      },
      labelsVersion: 0,
      labelList: [
        { label: 'BusinessImportHistory.page.importBatchNumber', prop: 'batch', isCheck: true, disabled: false },
        { label: 'BusinessImportHistory.page.totalData', prop: 'dataCount', isCheck: true, disabled: false },
        { label: 'table.statusText', prop: 'statusMeaning', isCheck: true, disabled: false },
        { label: 'table.createdByText', prop: 'createdUserName', isCheck: true, disabled: false },
        { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129 },
      ],
      queryParamsTime: null,
    };
  },
  computed: {},
  watch: {
    queryParamsTime(v) {
      this.queryParams.creationDateFrom = (v || [])[0];
      this.queryParams.creationDateTo = (v || [])[1];
    },
  },
  created() {},
  mounted() {},
  methods: {
    beforeQuerySearch(conditionObj) {
      return new Promise(resolve => {
        resolve(conditionObj);
      });
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    handleChangeTemplate(v, item) {
      this.queryParams.prefix = item.prefixPatch;
    },
  },
};
</script>
